import { useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import { cloneDeep } from "lodash";
import defineConf from "../../config/defineConf";

function MomSysOrderBuyerPurchaseDetailUpdateButton(props) {
    const { t } = useTranslation();

    const { id, schema, grid, onSuccess, customizeErrorMsgCallback, title, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [modifiedSchema, setModifiedSchema] = useState(schema);

    const onOpen = () => {
        if (grid) {
            const selectTarget = grid.selectedItems[0];

            let modifiedSchema = cloneDeep(schema);

            if (modifiedSchema) {
                for (const column of modifiedSchema.columns) {
                    switch (column.name) {
                        case "qty":
                        case "description":
                            break;

                        case "unitCost":
                            if (selectTarget.opCode === defineConf.opCode.PUR2) {
                                column.hideInForm = false;
                            }
                            break;

                        case "processingPlaneCount":
                            if (selectTarget.opCode === defineConf.opCode.PUR2) {
                                column.hideInForm = true;
                            }
                            break;

                        default:
                            column.hideInForm = true;
                            break;
                    }
                }
            }
            setModifiedSchema(modifiedSchema);

            setFormData({ ...selectTarget });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onUpdateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }
    };

    return (
        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={title ? title : schema ? t(`dialog.title.${schema.name}.update`) : ""}
                schema={modifiedSchema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>
    );
}

export default MomSysOrderBuyerPurchaseDetailUpdateButton;
